module.exports = __webpack_public_path__ + "static/media/avatar_cropped_resized_transparent.f21b2eec.png";